import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import { DomUtil } from "../../util/DomUtil";
import { SavedPageService } from "../../service/SavedPageService";
import { EventUtil } from "../../util/EventUtil";
import { HealioHeader } from "../healioGlobal/HealioHeader";

export class PinnedSeries extends Component {
  private readonly _loadingElement: HTMLElement | null;
  private readonly _loginElement: HTMLElement | null;
  private readonly _savedPageService: SavedPageService | null;

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);
    this._loadingElement = this._element.querySelector('[data-content="loading"]')
    this._loginElement = this._element.querySelector('[data-content="login"]')
    this._savedPageService = context ? context.savedPageService : null;

    const loginLinks = this._element.querySelectorAll("[data-force-login]")
    loginLinks?.forEach(loginLink => {
      loginLink.addEventListener("click", () => this.forceLogin() )
    })

    if (this._savedPageService) {
      window.addEventListener(
        SavedPageService.SavedPageIncrementEvent,
        ev => this.handlePinAdded(ev as CustomEvent<string>));


      window.addEventListener(
        SavedPageService.SavedPageDecrementEvent,
        ev => this.handlePinRemoved(ev as CustomEvent<string>));
    }
  }

  public async init(): Promise<void> {
    const profile = await WyanokeUtil.loadUserProfile(true, false);
    if (!profile || profile.isLoggedIn === "False") {
      this._loginElement?.classList.remove("d-none")
      this.hideLoadingElement()
      return;
    }

    await this.loadPinned();
  }

  private async forceLogin():Promise<void> {
    this._element.dispatchEvent(
      EventUtil.createCustomEvent(
        HealioHeader.UnauthenticatedActionEvent,
        null));
  }

  private async handlePinAdded(ev: CustomEvent<string>): Promise<void> {
    const elementPinned = DomUtil.query(document.body, `[data-activity-id='${ev.detail}']`);

    if(elementPinned && elementPinned.dataset.contentType === this._element.dataset.contentType){
      const pinnedSeriesCard = elementPinned?.closest(".card")
      this._element.innerHTML += pinnedSeriesCard?.outerHTML
      await this._pageContext?.componentFactory.loadComponents(this._element);
      this.showOrHideEmptyElement()
      this.insureAllPinnedAreActive()
    }

    return
  }

  private async handlePinRemoved(ev: CustomEvent<string>): Promise<void> {
    const existingPinnedSeriesCard = this._element.querySelector(`[data-activity-id='${ev.detail}']`)?.closest(".card")
    if(existingPinnedSeriesCard) {
      existingPinnedSeriesCard.remove()
    }
    this.showOrHideEmptyElement()
    return
  }

  private insureAllPinnedAreActive() : void {
    const pinnedCards = this._element.querySelectorAll(".card")
    pinnedCards.forEach(pinnedCard => {
      const pinElement = pinnedCard.querySelector<HTMLElement>(".pin")
      if(pinElement) {
        pinElement.classList.add("active")
        pinElement.dataset.stateCurrent = "saved"
      }
    })
  }

  private showOrHideEmptyElement() :void {
    const pinnedSeriesCards = this._element.querySelectorAll(".card")
    const emptyElement = this._element.querySelector('[data-content="empty"]')
    if(!emptyElement){
      return
    }
    if(pinnedSeriesCards && pinnedSeriesCards.length < 1){
      emptyElement.classList.remove("d-none")
      emptyElement.parentElement?.classList.remove("d-none")
    } else {
      emptyElement.classList.add("d-none")
      emptyElement.parentElement?.classList.add("d-none")
    }
  }

  private hideLoadingElement(): void {
    this._loadingElement?.classList.remove("active")
    this._loadingElement?.classList.add("d-none")
  }

  private async loadPinned(): Promise<void> {
    const context = this._pageContext;
    const service = context ? context.savedPageService : null;

    let contentType = this._element.dataset.contentType;


    if (this._element.dataset.siteName === undefined) {
      console.warn("No siteName Card");

      return;
    }

    if (!contentType) {
      console.warn("Missing Content Type from data attributes")

      return;
    }


    if (!service) {
      console.warn("No Saved Page Service available.");

      return;
    }

    let pinnedSeriesItems = await service.list(contentType);

    const activitySiteName = this._element.dataset.siteName.toLowerCase();

    if (pinnedSeriesItems === null || pinnedSeriesItems.length < 1) {
      this.hideLoadingElement()
      this.showOrHideEmptyElement()
      return;
    }

    pinnedSeriesItems = pinnedSeriesItems.filter(
      s => s.site && s.site.toLowerCase() === activitySiteName
    )
    this.hideLoadingElement()
    if (pinnedSeriesItems && pinnedSeriesItems.length >= 1) {
      pinnedSeriesItems.forEach(seriesItem => {
        const pinnedItem = DomUtil.query(document.body, `[data-activity-id='${seriesItem.documentid}']`).closest(".card");
        this._element.innerHTML += pinnedItem?.outerHTML
      })

      await this._pageContext?.componentFactory.loadComponents(this._element);
    }
    this.showOrHideEmptyElement()
  }
}

ComponentFactory.registerComponent("PinnedSeries",
  PinnedSeries);
